import brands from './brands.json';

const brandsWithImagesImport = brands.map(b => {
  return {
    ...b,
    logoSrc: require('' + b.logoSrc)
  };
});

export default brandsWithImagesImport;